import MagnifyPlusTool from '../../../../../customTools/MagnifyPlusTool';
import MoveFrameTool from '../../../../../customTools/MoveFrameTool';

//descriptor de tools
export const defaultTools = [
  // Mouse
  {
    name: 'Wwwc',
    mode: 'active',
    modeOptions: { mouseButtonMask: 1 },
  },
  {
    name: 'Pan',
    mode: 'active',
    modeOptions: { mouseButtonMask: 4 },
  },
  {
    name: 'FreehandRoiTool',
    mode: 'active',
    modeOptions: { mouseButtonMask: 1 },
  },
  {
    name: 'MagnifyPlusTool',
    mode: 'active',
    toolClass: MagnifyPlusTool,
  },
  // Scroll
  { name: 'StackScrollMouseWheel', mode: 'active' },
  { name: 'MoveFrame', mode: 'active', toolClass: MoveFrameTool },
  // Touch
  { name: 'PanMultiTouch', mode: 'active' },
  { name: 'ZoomTouchPinch', mode: 'active' },
  { name: 'StackScrollMultiTouch', mode: 'active' },
  { name: 'RotateTouch', mode: 'active' }, // testing this one on device
  { name: 'Overlay', mode: 'active' },
];
